import React, { useEffect, useState } from "react";
import TableContainer from "../../../Component/TableContainer";
import {
  Box,
  Checkbox,
  Dialog,
  IconButton,
  Switch,
  Typography,
} from "@mui/material";
import { Link, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  CheckCircle,
  DeleteOutline,
  EditOffOutlined,
  EditOutlined,
  RadioButtonUncheckedOutlined,
} from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import { shiftInstructionList } from "../../../SampleData/ShiftInstructionList";
import ShiftInstructionModal from "./ShiftInstructionModal";

const ShiftInstructionList = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const actionsAllow = useSelector((state) => state.dataRed.actionsAllow);

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(shiftInstructionList);
  const [create, setCreate] = useState(false);
  const [mode, setMode] = useState("");
  const [editData, setEditData] = useState({});
  const [filterValue, setFilterValue] = useState("enableData");
  const [backUpData, setBackUpData] = useState([]);

  //   useEffect(() => {
  //     getData();
  //   }, []);

  //   const getData = async() => {
  //     setIsLoading(true);
  //     const link = masterAPI["assetCategory"].link;
  //    await axiosPrivate
  //       .get(`${link}`)
  //       .then((res) => {
  //         res.data.result.sort((a, b) => {
  //           return a.code.localeCompare(b.code, undefined, {
  //             numeric: true,
  //             sensitivity: 'base'
  //           });
  //         });
  //         if(filterValue==="enableData"){
  //           const filterDataResult=res.data.result.filter(fil=>fil.isActive)
  //           console.log(filterDataResult, "locationresult");
  //           setData(filterDataResult);
  //           setBackUpData(res.data.result)
  //         }else{
  //           setData(res.data.result)
  //           setBackUpData(res.data.result)
  //         }
  //         setIsLoading(false);
  //       })
  //       .catch((e) => {
  //         console.log(e, "assetCategory");
  //         setIsLoading(false);
  //         setData([])
  //         setBackUpData([])
  //       });
  //   };

  const handleButtonNew = () => {
    // setMode("Create");
    // setCreate(true);
  };
  const handleCreate=()=>{
    setCreate(true)
  }
  const handleCreateClose = () => {
    setMode("");
    setCreate(false);
    // getData();
  };

//   const handleEdit = (data) => {
//     setEditData(data);
//     setMode("Edit");
//     setCreate(true);
//   };

  const columns = [
    {
      Header: "User",
      accessor: "API_user",
      Cell: ({ cell }) => {
        return (
          <Typography
            sx={{
              color: "#0d6efd",
              textDecorationLine: "underline",
              fontWeight: 800,
              cursor: "pointer",
              fontSize:"inherit"
            }}
            onClick={handleCreate}
          >
            {cell.value}
          </Typography>
        );
      },
      // disableFilters: true,
    },
    {
      accessor: "Read",
      disableFilters: true,
      Cell: ({ cell }) => {
        return (
          <Box sx={{ width: color.checkBoxWidth }}>
            <Checkbox
              checked={cell.value === "No" ? false : true}
              // icon={<RadioButtonUncheckedOutlined />}
              // checkedIcon={<CheckCircle />}
            />
          </Box>
        );
      },
    },
    {
      Header: "Instruction name",
      accessor: "Instruction_name",
      // disableFilters: true,
    },
    {
      Header: "Created by",
      accessor: "Created_by",
    },
    {
      Header: "Valid from date",
      accessor: "Valid_from_date",
    },
    {
      Header: "Valid to date",
      accessor: "Valid_to_date",
    },
    // {
    //   Header: "Actions",
    //   Cell: ({ cell }) => {
    //     // console.log(cell)
    //     return (
    //       <Box sx={{ whiteSpace: "nowrap" }}>
    //         <IconButton disabled={!actionsAllow.edit}>
    //           <EditOutlined
    //             onClick={() => {
    //               handleEdit(cell.row.original);
    //             }}
    //             sx={{
    //               fontSize: color.masterEditDelButton,
    //               color:actionsAllow.edit? color.masterEditDelButtonColor:"default",
    //             }}
    //           />
    //         </IconButton>
    //         {/* <IconButton
    //         disabled={!actionsAllow.delete}
    //         >
    //           <DeleteOutline
    //             onClick={() => {
    //               handleDelete(cell.row.original.id);
    //             }}
    //             sx={{
    //               fontSize: color.masterEditDelButton,
    //               color:actionsAllow.delete? color.masterEditDelButtonColor:"default",
    //             }}
    //           />
    //         </IconButton> */}
    //         <Switch
    //         disabled={!actionsAllow.delete}
    //         checked={cell.row.original.isActive}
    //         onChange={(e)=>{handleDelete(e,cell.row.original.id)}}

    //          />
    //       </Box>
    //     );
    //   },
    // },
  ];

  const handleChangeFilter = (e) => {
    if (e === "showAll") {
      setData(backUpData);
    } else {
      const filterDataResult = backUpData.filter((fil) => fil.isActive);

      setData(filterDataResult);
    }
    setFilterValue(e);
  };

  return (
    <>
      <Box>
        <Typography
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
            mb: color.masterPageTitlemd,
          }}
        >
          Shift Instruction
        </Typography>
      </Box>

      <TableContainer
        columns={columns}
        data={data}
          buttonNew={handleButtonNew}
        loading={isLoading}
        buttonDisable={!actionsAllow.create}
        //   filterValue={filterValue}
        //   handleChange={handleChangeFilter}
        filterShow={false}
        display={"notVisible"}
      />

      <Dialog
        open={create}
        onClose={handleCreateClose}
        maxWidth={"md"}
        children={
          <ShiftInstructionModal
            handleCloseClick={handleCreateClose}
            mode={mode}
            editData={editData}
          />
        }
      />
    </>
  );
};

export default ShiftInstructionList;
